import React from "react";
import ModelResultMonthlyPrice from "./ModelResultMonthlyPrice";
import ModelResultCashPrice from "./ModelResultCashPrice";
import type { ModelResultType } from "../../../../../../../shared-logic/features/filters/utils/constants/resultConstants";
import { isIsrael } from "../../../../../../../common-deprecated/settings/utils/commonSettingUtils";
import ModelResultCashPriceIsrael from "./ModelResultCashPriceIsrael";
import type { CommonSettingsType } from "../../../../../../../common-deprecated/settings/fetchCommonSettings";
import { getCashPriceDisclaimerLabel } from "../../../../../../../common-deprecated/settings/utils/financeSettingUtilsAem";

type ModelResultPriceType = {
    model: ModelResultType;
    commonSettings: CommonSettingsType;
};

const ModelResultPrice = (props: ModelResultPriceType): JSX.Element | null => {
    const { model, commonSettings } = props;
    const { cars, cheapestCar = cars[0], cheapestCarMonthly = cars[0] } = model;

    const cashPriceDisclaimer = cheapestCar.model.labels;
    // Cash and monthly are separate components for easier readability and maintenance.
    return (
        <>
            {isIsrael(commonSettings.culture.name) ? (
                <ModelResultCashPriceIsrael
                    price={cheapestCar?.price}
                    modelCode={cheapestCar.model.code}
                    cashPriceDisclaimer={cashPriceDisclaimer && getCashPriceDisclaimerLabel(cashPriceDisclaimer)}
                />
            ) : (
                <ModelResultCashPrice
                    price={cheapestCar?.price}
                    modelCode={cheapestCar.model.code}
                    cashPriceDisclaimer={cashPriceDisclaimer && getCashPriceDisclaimerLabel(cashPriceDisclaimer)}
                />
            )}
            {!!cheapestCarMonthly?.price.monthly && (
                <ModelResultMonthlyPrice
                    financeInfo={cheapestCarMonthly.finance}
                    price={cheapestCarMonthly.price}
                    modelCode={cheapestCarMonthly.model.code}
                />
            )}
        </>
    );
};

export default ModelResultPrice;
